<template>
  <div>
    <div class="neutral--text text--tone-400 text-label-m mb-2">{{ title }}</div>
    <v-select
      v-bind="$attrs"
      color="brand-primary tone-400"
      flat
      :items="items"
      :label="label"
      :multiple="multiple"
      @change="$emit('change', $event); isActive = false"
      @blur="isActive = false"
      item-text="attributes.name"
      item-value="id"
      :value="selected"
      :chips="multiple"
      :deletable-chips="multiple"
      solo
      class="text-body-m neutral--text text--tone-400 custom-dropdown"
      :menu-props="{
        offsetY: true,
        bottom: true,
        contentClass: 'text-body-m neutral--text text--tone-400 white',
      }"
      @click="isActive = true"
    >
    <template #append>
      <font-awesome-icon
        icon="fa-light fa-angle-down"
        class="brand-primary--text text--tone-400 toggleUpDown"
        :class='{ "rotate": isActive }'
        size="lg"
      />
    </template>

    <template #item="{ item, attrs, on }">
      <v-list-item
        v-on="on"
        v-bind="attrs"
        #default="{ active }"
        class="select-item ma-1"
      >
        <v-list-item-content>
          <v-list-item-title>
            <v-row
              no-gutters
              align="center"
            >
              <span class="text-body-m neutral--text">
                {{ item.attributes.name || item }}
              </span>
              <v-spacer></v-spacer>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <font-awesome-icon
            v-if="active"
            icon="fa-regular fa-check"
            :class="[{'brand-primary--text text--tone-400': active}]"
            size="lg"
          />
        </v-list-item-action>
      </v-list-item>
    </template>
    </v-select>
  </div>
</template>

<script>
export default {
  name: 'BaseSelect',
  props: {
    title: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    multiple: {
      type: Boolean,
      required: false,
    },
    selected: {
      type: [String, Array],
      default: undefined,
    },
  },
  data() {
    return {
      isActive: false,
    };
  },
};
</script>

<style lang="scss">

.v-menu__content {
  max-height: 232px !important;
  border-radius: 8px !important;

  /* Scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: var(--v-brand-primary-tone-400);
    border-radius: 2px;
  }
}

.v-menu__content .v-list {
  z-index: 10;
  padding-top: 0px;
  padding-bottom: 0px;

  .v-list-item {
    padding: 4px 16px;
  }

  .v-list-item__content {
    padding: 0px 0px 0px 0px;
  }

  .v-list-item--active {
    background-color: var(--v-neutral-tone-200) !important;
    color: var(--v-neutral-tone-200) !important;
    border-radius: 6px !important;

    .v-list-item__title {
      color: var(--v-neutral-tone-500) !important;
    }
  }
}

.custom-dropdown {

  .v-input__control {
    .v-input__slot {
      border: 1px solid var(--v-neutral-tone-200);
      border-radius: 8px !important;
    }
  }
}

.v-select--is-menu-active {
  .v-input__control {
    .v-input__slot {
      border: 1px solid var(--v-brand-primary-tone-400);
    }
  }
}

.toggleUpDown {
  transition: transform .3s ease-in-out !important;
}

.toggleUpDown.rotate {
  transform: rotate(180deg);
}
</style>
